const environmentPay = {
  SANDBOX: 'SANDBOX',
  PRODUCTION: 'PRODUCTION',
};

const local = {
  s3: {
    BUCKET: '994514690620-images',
  },
  api: {
    ENDPOINT: 'http://localhost:3500/local',
  },
  map: {
    API_KEY: 'AIzaSyCcx_0_2S7C6E-FXfBe7ne8aDrjwBye5x8',
  },
  payment: {
    apiLoginID: process.env.REACT_APP_AUTHNET_API_LOGIN_ID,
    clientKey: process.env.REACT_APP_AUTHNET_PUBLIC_CLIENT_KEY,
    environment: environmentPay.SANDBOX,
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_oEkmDAGsK',
    APP_CLIENT_ID: '25hv7pfd6cqr4mi124pk4tnb7g',
    AUTHENTICATION_TYPE: 'AMAZON_COGNITO_USER_POOLS',
    IDENTITY_POOL_ID: 'us-east-1:be892775-880e-4e2c-b371-3ab25ed5295a',
    M2M_CLIENT_ID: '6n8prc3o7pb942kkgtlt37s76s',
    M2M_CLIENT_SECRET: '128tbj8p5ui1d15lfqlbfbruqeosn603t512e30vjn1j8qus12mf',
    M2M_SCOPE: 'default-m2m-resource-server-fe7hpn/read',
    USER_POOL_M2M: 'us-east-1oekmdagsk',
    API_URL: 'https://npm30qghwh.execute-api.us-east-1.amazonaws.com/prod/query',
  },
  graphql: {
    ENDPOINT: 'https://nxwzl2ajzrfgzip65ivawz7nzm.appsync-api.us-east-1.amazonaws.com/graphql',
  },
};

const dev = {
  s3: {
    BUCKET: '994514690620-images',
  },
  api: {
    ENDPOINT: 'https://9tfuah4glf.execute-api.us-east-1.amazonaws.com/dev',
  },
  map: {
    API_KEY: 'AIzaSyCcx_0_2S7C6E-FXfBe7ne8aDrjwBye5x8',
  },
  payment: {
    apiLoginID: process.env.REACT_APP_AUTHNET_API_LOGIN_ID,
    clientKey: process.env.REACT_APP_AUTHNET_PUBLIC_CLIENT_KEY,
    environment: environmentPay.SANDBOX,
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_oEkmDAGsK',
    APP_CLIENT_ID: '25hv7pfd6cqr4mi124pk4tnb7g',
    AUTHENTICATION_TYPE: 'AMAZON_COGNITO_USER_POOLS',
    IDENTITY_POOL_ID: 'us-east-1:be892775-880e-4e2c-b371-3ab25ed5295a',
    M2M_CLIENT_ID: '6n8prc3o7pb942kkgtlt37s76s',
    M2M_CLIENT_SECRET: '128tbj8p5ui1d15lfqlbfbruqeosn603t512e30vjn1j8qus12mf',
    M2M_SCOPE: 'default-m2m-resource-server-fe7hpn/read',
    USER_POOL_M2M: 'us-east-1oekmdagsk',
    API_URL: 'https://npm30qghwh.execute-api.us-east-1.amazonaws.com/prod/query',
  },
  graphql: {
    ENDPOINT: 'https://nxwzl2ajzrfgzip65ivawz7nzm.appsync-api.us-east-1.amazonaws.com/graphql',
  },
};

const stage = {
  s3: {
    BUCKET: '186546463478-images',
  },
  api: {
    ENDPOINT: 'https://r1rj5u1xpd.execute-api.us-east-1.amazonaws.com/test',
  },
  map: {
    API_KEY: 'AIzaSyCcx_0_2S7C6E-FXfBe7ne8aDrjwBye5x8',
  },
  payment: {
    apiLoginID: process.env.REACT_APP_AUTHNET_API_LOGIN_ID,
    clientKey: process.env.REACT_APP_AUTHNET_PUBLIC_CLIENT_KEY,
    environment: environmentPay.SANDBOX,
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_uxFzKeYal',
    APP_CLIENT_ID: '79er2fvh7nsm1s671gkrg2ndro',
    AUTHENTICATION_TYPE: 'AMAZON_COGNITO_USER_POOLS',
    IDENTITY_POOL_ID: 'us-east-1:0f7a038c-c10e-4dd2-a883-aeb08ceca9cb',
    M2M_CLIENT_ID: '6n8prc3o7pb942kkgtlt37s76s',
    M2M_CLIENT_SECRET: '128tbj8p5ui1d15lfqlbfbruqeosn603t512e30vjn1j8qus12mf',
    M2M_SCOPE: 'default-m2m-resource-server-fe7hpn/read',
    USER_POOL_M2M: 'us-east-14zf0y52b0',
    API_URL: 'https://oql4i63pxj.execute-api.us-east-1.amazonaws.com/prod/query',
  },
  graphql: {
    ENDPOINT: 'https://d53n2rpcdbaxdp2mpwhmylb77y.appsync-api.us-east-1.amazonaws.com/graphql',
  },
};

const prod = {
  s3: {
    BUCKET: '873670750101-images',
  },
  api: {
    ENDPOINT: 'https://api.fayven.com',
  },
  map: {
    API_KEY: 'AIzaSyCcx_0_2S7C6E-FXfBe7ne8aDrjwBye5x8',
  },
  payment: {
    apiLoginID: process.env.REACT_APP_AUTHNET_API_LOGIN_ID,
    clientKey: process.env.REACT_APP_AUTHNET_PUBLIC_CLIENT_KEY,
    environment: environmentPay.PRODUCTION,
  },
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_4ZF0y52b0',
    APP_CLIENT_ID: '73njoaagtjrlirn6hg9ifute0c',
    AUTHENTICATION_TYPE: 'AMAZON_COGNITO_USER_POOLS',
    IDENTITY_POOL_ID: 'us-east-1:8b8751a8-17e4-412c-86b2-e732344910a8',
    M2M_CLIENT_ID: '78ncpt2s0jt69bojkjq4946504',
    M2M_CLIENT_SECRET: '9qd623diedghfslt63je38mnvo50196ke6jb2h01qlhb441bqcd',
    M2M_SCOPE: 'default-m2m-resource-server-1rm72y/read',
    USER_POOL_M2M: 'us-east-14zf0y52b0',
    API_URL: 'https://oql4i63pxj.execute-api.us-east-1.amazonaws.com/prod/query',
  },
  graphql: {
    ENDPOINT: 'https://fwno5kbmvfglrevx3vp2z45fwi.appsync-api.us-east-1.amazonaws.com/graphql',
  },
};

// eslint-disable-next-line no-nested-ternary
const config =
  // eslint-disable-next-line no-nested-ternary
  process.env.REACT_APP_STAGE === 'prod'
    ? prod
    : // eslint-disable-next-line no-nested-ternary
    process.env.REACT_APP_STAGE === 'test'
    ? stage
    : // eslint-disable-next-line no-nested-ternary
    process.env.REACT_APP_STAGE === 'dev'
    ? dev
    : local;

const sharedObj = {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config,
};
export default sharedObj;
